




import Vue from 'vue';
import {Component} from "vue-property-decorator";
import AsiToolbar from "./AsiToolbar.vue";
import AsiTextFieldSimple from "./AsiTextFieldSimple";
import AsiBtn from "@/components/common/AsiBtn.vue";
import AsiListTableAdvancedFilters from "@/components/common/AsiListTableAdvancedFilters.vue";
import PaginatedResponse from "@/models/PaginatedResponse";
import {PerPageOptions} from "@/helpers/constants";
import IListFilter from "@/models/IListFilter";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import {isEmpty} from "@/helpers/functions_asi";
import IAsiListTableImplementation from "@/components/common/IAsiListTableImplementation";
import {SnackbarMessage} from "@/models/SnackbarMessage";

@Component({
	components: {AsiListTableAdvancedFilters, AsiBtn, AsiTextFieldSimple, AsiToolbar}
})
export default class AsiListTable<T, U extends IListFilter> extends Vue {

	protected data: PaginatedResponse<T> | null = null;
	protected filterModel: U | null = null;
	protected tableOptions: AsiListTableOptions = new AsiListTableOptions();
	protected filterText: string | null = null;
	protected isLoading: boolean = false;

	protected get items(): T[] {
		return this.data?.data ?? [];
	}

	protected get total(): number {
		return this.data?.total ?? 0;
	}

	private get hasFilter(): boolean {
		return (this.filterModel?.hasFilter() ?? false) || !isEmpty(this.filterText);
	}

	protected reloadInternal(implementation: IAsiListTableImplementation<T, U>, goToFirstPage: boolean = false): void {
		if (goToFirstPage) {
			this.tableOptions.page = 1;
		}

		this.isLoading = true;
		try {
			implementation.fetchData(this.filterModel, this.tableOptions)
				.then(res => {
					this.data = res;
				})
				.catch(() => {
					this.$store.commit('ui/showSnackbar', {
						message: this.$t('snackbar.loadingError'),
						color: 'error',
					} as SnackbarMessage);
				})
				.finally(() => {
					this.isLoading = false;
				});
		} catch (ex) {
			this.isLoading = false;
		}
	}

	protected clearSearch(): void {
		this.filterModel?.clear();
		this.filterText = null;
	}

	protected getPerPageOptions(): number[] {
		return PerPageOptions;
	}

}
